import * as React from "react";
import type { ReactNode } from "react";

import { UpdateHeightCallbackProvider } from "../../../Internals/UpdateHeightCallbackContext/UpdateHeightCallbackContext";
import { RowRemovedHandler } from "../../../Internals/ControlContexts/MultilineRowHeightContext";

import { Root } from "./Row.styles";

export interface RowProps {
    children?: ReactNode;
    removeButton: ReactNode;
    removeButtonPosition?: "first";
    showRowBorder: boolean;
    highlightHoveredRow: boolean;
    height: number;
    instanceId: string;
    onClick: (instance: string) => void;
    onHeightChange: (rowHeight: number) => void;
    onRowRemoved: RowRemovedHandler;
}

export class Row extends React.PureComponent<RowProps> {
    private cellsHeights: Record<string, number> = {};

    private readonly handleOnClick = () => {
        if (this.props.onClick != undefined) {
            this.props.onClick(this.props.instanceId);
        }
    };

    public componentWillUnmount(): void {
        this.props.onRowRemoved(this.props.instanceId);
    }

    private readonly updateCellsHeight = (cellId: string, cellHeight: number) => {
        this.cellsHeights[cellId] = cellHeight;
        const newRowHeight = this.getMaxCellsHeight();
        this.props.onHeightChange(newRowHeight);
    };

    private getMaxCellsHeight(): number {
        return Math.max(...Object.values(this.cellsHeights)) || 0;
    }

    public render = () => (
        <Root
            style={{ height: this.props.height }}
            showRowBorder={this.props.showRowBorder}
            highlightHoveredRow={this.props.highlightHoveredRow}
            onClick={this.handleOnClick}>
            <UpdateHeightCallbackProvider onUpdate={this.updateCellsHeight}>
                {this.props.removeButtonPosition === "first" && this.props.removeButton}
                {this.props.children}
                {this.props.removeButtonPosition !== "first" && this.props.removeButton}
            </UpdateHeightCallbackProvider>
        </Root>
    );
}
